/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["abbr[_ngcontent-%COMP%]{font-weight:700;font-style:italic}"];
export { styles as styles };
